import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit, inject, signal } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DiscussionComponent } from './discussion.component';

@Component({
  selector: 'etxe-discussion-page',
  imports: [CommonModule, DiscussionComponent],
  template: `
    <!-- Chat Interface Container -->
    <div class="w-full h-full">
      <etxe-discussion
        [discussionId]="activeDiscussionId()"
        (discussionSelected)="onDiscussionSelected($event)"
      ></etxe-discussion>
    </div>
  `,
  host: {
    class: 'block w-full h-full',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DiscussionPageComponent implements OnInit {
  private readonly route = inject(ActivatedRoute);
  private readonly router = inject(Router);

  readonly activeDiscussionId = signal<string | null>(null);

  ngOnInit() {
    this.route.paramMap.subscribe((params) => {
      const id = params.get('discussionId');
      this.activeDiscussionId.set(id);
    });
  }

  onDiscussionSelected(id: string) {
    void this.router.navigate(['/messages', id], { replaceUrl: true });
  }
}
